import { Routes, Route } from "react-router-dom";
import Footr from "./components/Footr";
import Headr from "./components/Headr";
import Creator from "./pages/creator/Creator";
import { ExperienceProvider } from "./pages/creator/ExperienceContext";
import Dashboard from "./pages/home/Dashboard";
import Login from "./pages/login/Login";
import Signup from "./pages/signup/Signup";
import Adduser from "./pages/adduser/Adduser";
import OTPSetPassword from "./pages/set-password/OTPSetPassword";
import SetPassword from "./pages/set-password/SetPassword";
import ForgotPassword from "./pages/forgot-password/ForgotPassword";
import OTPForgotPassword from "./pages/forgot-password/OTPForgotPassword";
import ResetPassword from "./pages/forgot-password/ResetPassword";
import Profile from "./pages/profile/Profile";
import PrivateRoute from "./components/PrivateRoute";
import Assets from "./pages/assets/Assets";
function AppRoutes() {
	return (
		<Routes>
			<Route path="/" element={<Login />} />
			<Route
				path="creator"
				element={
					<PrivateRoute>
						<ExperienceProvider>
							<Creator />
						</ExperienceProvider>
					</PrivateRoute>
				}
			/>
			<Route path="login" element={<Login />} />
			<Route path="signup" element={<Signup />} />
			<Route
				path="assets"
				element={
					<PrivateRoute>
						<Assets />
					</PrivateRoute>
				}
			/>
			<Route
				path="adduser"
				element={
					<PrivateRoute>
						<Adduser />
					</PrivateRoute>
				}
			/>
			<Route path="OTPSetPassword" element={<OTPSetPassword />} />
			<Route path="setPassword" element={<SetPassword />} />
			<Route path="ForgotPassword" element={<ForgotPassword />} />
			<Route path="OTPForgotPassword" element={<OTPForgotPassword />} />
			<Route path="resetPassword" element={<ResetPassword />} />
			<Route path="footer" element={<Footr />} />
			<Route path="header" element={<Headr />} />
			<Route
				path="/dashboard"
				element={
					<PrivateRoute>
						<Dashboard />
					</PrivateRoute>
				}
			/>
			<Route
				path="profile"
				element={
					<PrivateRoute>
						<Profile />
					</PrivateRoute>
				}
			/>
			<Route path="*" element={<h1>404 Page</h1>} />
		</Routes>
	);
}

export default AppRoutes;
